import gql from 'graphql-tag'

export const GET_CART_RECOMMENDATIONS = gql`
  query cartPageRecommendations(
    $productIds: [String!]!
    $noOfProducts: Int
    $minPrice: Float
    $maxPrice: Float
  ) {
    cartPageRecommendations(
      productIds: $productIds
      noOfProducts: $noOfProducts
      minPrice: $minPrice
      maxPrice: $maxPrice
    ) {
      productReferences {
        id
        ticket
        product {
          id
          productErpIdentifier
          displayName
          englishFullDisplayName
          primaryImageId
          manufacturerName
          manufacturerProductIdentifier
          oneLiner
          internalProduct
          displaySpecifications
          nameSlug
          energyClass
          energyLabelImageId
          reviewScore
          reviewCount
          isNewProduct
          minQuantityPerOrder
          maxQuantityPerOrder
          price {
            campaignPercentage
            campaignType
            formatted {
              price
              originalPrice
              priceExcludingVat
              priceIncludingVat
            }
            isBestSeller
            isBid
            isCampaign
            isRecommendedProduct
            price
            priceExcludingVat
            priceIncludingVat
            originalPrice
            priceVat
          }
          availability {
            IsNotifyEligible
            maxAvailableQuantity
            internalEtaStock {
              eta
              quantity
            }
            externalStock {
              leadTime
              quantity
            }
            availabilityDetails {
              formattedDateUtc
              key
            }
            availabilityStatus
            availabilityStatusPresentation
            internalStock {
              quantity
              showAlwaysInStock
            }
            isAvailableForSale
            isPreOrder
            productLifeCycleState
            showAvailabilityQuantities
            showEtaDate
          }
        }
      }
    }
  }
`
